exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".samples_LxKBU {\n    text-align: center;\n}\n.signatureContainer_CsLXm {\n    padding-top: 10px;\n}\n\n.signatureEnrollment_1ffff {\n    width: 100%;\n    text-align: center;\n}\n\n.signatureEnrollment_1ffff td {\n    vertical-align: bottom;\n}\n\n.gapSection4_1Mm44 {\n    height: 30px;\n}\n", ""]);

// exports
exports.locals = {
	"samples": "samples_LxKBU",
	"signatureContainer": "signatureContainer_CsLXm",
	"signatureEnrollment": "signatureEnrollment_1ffff",
	"gapSection4": "gapSection4_1Mm44"
};